import React, { useState } from 'react';
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useToast,
} from '@chakra-ui/react';
import { useMutation } from 'react-query';
import UserService from '../../services/UserService';

const OTPDialog = ({ userId, onClose }) => {
  const toast = useToast();
  const [otp, setOtp] = useState('');

  const mutation = useMutation(() => UserService.verifyOTP(userId, otp), {
    onSuccess: () => {
      toast({
        title: "Phone number verified successfully.",
        status: "success",
        duration: 5000,
        isClosable: true,
      });
      onClose();
    },
    onError: (error) => {
      toast({
        title: "Error verifying phone number.",
        description: error.response.data.message,
        status: "error",
        duration: 5000,
        isClosable: true,
      });
    }
  });

  const handleVerify = () => {
    mutation.mutate();
  };

  return (
    <Modal isOpen={true} onClose={onClose}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Verify Phone Number</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <FormControl>
            <FormLabel htmlFor="otp">OTP</FormLabel>
            <Input id="otp" value={otp} onChange={(e) => setOtp(e.target.value)} />
          </FormControl>
        </ModalBody>
        <ModalFooter>
          <Button colorScheme="teal" isLoading={mutation.isLoading} onClick={handleVerify}>
            Verify
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default OTPDialog;
